var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForm8821OnFileFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Form_8821_-_On_File_Flag",
    "data-name": "Form 8821 - On File Flag",
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 29,
    viewBox: "0 0 94 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    fill: "#21b537",
    stroke: "#3ea82e",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 29,
    rx: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 93,
    height: 28,
    rx: 14,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "On_File",
    "data-name": "On File",
    transform: "translate(47 19)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22,
    y: 0
  }, "On File"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm8821OnFileFlag);
export default __webpack_public_path__ + "static/media/Form-8821-On-File-Flag.838ade7be9d54f9981e28dc23c51806d.svg";
export { ForwardRef as ReactComponent };